{
  "_provenance": {
    "ns": "landing",
    "source": "the public pages: pages/LandingPage.tsx and the /apply and /verify-email strings R2 left (#2109 R3 lane L8)"
  },
  "faq": {
    "chatbot": {
      "a": "No. It’s an AI assistant that works from your family’s account.",
      "q": "Is the assistant a person?"
    },
    "counter": "{{index}} / {{total}}",
    "invite": {
      "a": "Start with the Apply to TRF button at the top of this page. If your TRF contact sent you a code or link, use it.",
      "q": "Can I apply now?"
    },
    "label": "Common questions",
    "title": "Things parents ask <em>before signing up.</em>"
  },
  "features": {
    "companion": {
      "body": "Ask a question, jot down what’s on your mind, or work through the day’s agenda — by chat or voice, any hour. Your assistant keeps your family’s to-do list and appointments in one place.",
      "foot": "Chat + voice · to-dos and appointments",
      "num": "/ 01 · assistant",
      "title": "Talk to an assistant that already knows your situation."
    },
    "finances": {
      "body": "Upload receipts for non-medical expenses — travel, utilities, rent — and follow each one until it’s reimbursed. Ask your assistant when the next grant payment lands or which receipt TRF is still waiting on.",
      "foot": "Grant schedule · receipt status",
      "num": "/ 02 · grants",
      "title": "Receipts, reimbursements, and your grant in one view."
    },
    "label": "What’s inside",
    "title": "Your mental list in one place, <em>one conversation away</em>, so you can be present for your family."
  },
  "hero": {
    "apply": "Apply to TRF",
    "lede": "By chat or voice, day or night — ready to keep your family’s to-do list and appointments in order and answer questions about your grant.",
    "photoAlt": "Families on stage at a Tyler Robinson Foundation gala",
    "title": "A family assistant from the Tyler Robinson Foundation, <em>here for your family</em> through pediatric cancer."
  },
  "intro": {
    "examples": {
      "calendar": {
        "quote": "“Just tell me what’s on the calendar tomorrow.”",
        "who": "From the car, you could…"
      },
      "doctor": {
        "quote": "“Add a question for the doctor: can she swim this summer?”",
        "who": "From the hospital waiting room, you could…"
      },
      "receipt": {
        "quote": "“Which receipt is TRF still waiting on?”",
        "who": "From the kitchen table, you could…"
      }
    },
    "label": "Your assistant",
    "lede": "An AI assistant at the heart of the platform. It works from what’s already in your family’s account — your child’s appointments and medications, your to-do list, your grant.",
    "title": "An always-on assistant who already knows <em>your situation.</em>"
  },
  "mission": {
    "body": "TRF supports families emotionally and financially as they face a pediatric cancer diagnosis by providing grants for non-medical expenses. This is the next chapter — a 24/7 digital assistant that extends what TRF already does best: financial relief, real human support, a community that shows up.",
    "cta": "Visit trf.org →",
    "label": "About TRF",
    "title": "The Tyler Robinson Foundation has stood beside families with pediatric cancer since 2013."
  },
  "sms": {
    "body": "By signing up and confirming a phone number, you may receive text messages from TRF for sign-in codes and account security. Message and data rates may apply. Reply <strong>{{stop}}</strong> at any time to opt out, <strong>{{help}}</strong> for help.",
    "label": "SMS disclosure",
    "small": "We never share or sell your phone number. SMS opt-in is not a condition of using the platform. See our <smsTerms>SMS Terms</smsTerms> and <privacy>Privacy Policy</privacy>.",
    "title": "About text messages from TRF"
  },
  "trust": {
    "cost": {
      "body": "TRF Imagine is available to TRF families at no cost, one more way we stand by you.",
      "k": "Cost",
      "v": "Part of your TRF support"
    },
    "label": "Trust and privacy",
    "privacy": {
      "body": "What you share with TRF Imagine is used to help you, and we never sell your information. <privacy>Read our Privacy Policy.</privacy>",
      "k": "Privacy",
      "v": "Your privacy matters"
    },
    "safety": {
      "body": "Questions don’t keep office hours. TRF Imagine is ready day or night to help you find answers, think things through, and keep track of things.",
      "k": "Availability",
      "v": "Here when you need it"
    },
    "title": "Built with the same care <em>we’d want for our own families.</em>"
  }
}
